export const createPalLink = (sellerAccountId: string, productIds: string[]) =>
  `/pal/${sellerAccountId}/?product_ids=${productIds.join(',')}`;
